import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  fetchCompany,
  updateCompany,
  uploadLogo,
  deleteLogo
} from '../../actions/companies/apiRequests';
import { fetchProfile } from '../../actions/profile/actionCreators';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import Page from '../shared/Page';
import Loader from '../shared/Loader';
import CompanyDetailsPage from './CompanyDetailsPage';


export class MyCompanyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: null
    };
    this.onSave = this.onSave.bind(this);
  }

  static get propTypes() {
    return {
      profileId: PropTypes.string,
      companyId: PropTypes.string,
      isCompanyAdmin: PropTypes.bool,
      title: PropTypes.string,
      dispatchFetchProfile: PropTypes.func,
    }
  }

  componentDidMount() {
    fetchCompany(this.props.companyId)
      .then(company => this.setState({ company }));
  }

  uploadLogo({ id }, file=null, deleted) {
    if (file) {
      return uploadLogo(id, file);
    }

    if (deleted) {
      return deleteLogo(id);
    }

    return Promise.resolve();
  }

  onSave(company, logo, logoDeleted) {
    const { companyId, dispatchFetchProfile, profileId } = this.props;

    return updateCompany(companyId, company)
      .then(() => this.uploadLogo(company, logo, logoDeleted))
      .then(() => dispatchFetchProfile(profileId))
  }

  render() {
    const {
      isCompanyAdmin,
      title
    } = this.props;
    const { company } = this.state;

    return (
      <Choose>
        <When condition={!company}>
          <Page header={title}>
            <Loader />
          </Page>
        </When>
        <Otherwise>
          <CompanyDetailsPage
            company={company}
            editInfo={isCompanyAdmin}
            editUsers={isCompanyAdmin}
            editLogo={isCompanyAdmin}
            editIsn={isCompanyAdmin}
            editStatus={false}
            showStatusButton={false}
            editCustomerNumber={false}
            editSubscription={false}
            showSaveButton={isCompanyAdmin}
            onSave={this.onSave}
            myCompany={true}
            {...this.props}
          />
        </Otherwise>
      </Choose>
    );
  }
}

const mapStateToProps = ({ profile }) => ({
  profileId: profile.id,
  companyId: profile.companyId,
  isCompanyAdmin: profile.isCompanyAdmin
});

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchProfile: (id) => dispatch(fetchProfile(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withEulaRestrictions(withRoleRestrictions(MyCompanyPage))
);



// WEBPACK FOOTER //
// src/components/companyDetails/MyCompanyPage.jsx